// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#challenge-rules .fit-obj{width:90%;height:99.87%;margin:0 auto}#challenge-rules .content{width:100%;float:left}#challenge-rules .title{font-size:18px;font-weight:bold}#challenge-rules .bolder{font-weight:bold}#challenge-rules .insider{padding-left:1.2em;text-indent:-1.2em}#challenge-rules .insider-div{width:98%;float:right;padding-left:1.2em;text-indent:-1.2em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
